var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.correctedText)?_c('span',[_c('span',{style:({ display: 'none' }),attrs:{"id":"supplierCorrected"}},[_vm._v(_vm._s(_vm.fieldSupplier)+"||"+_vm._s(_vm.correctedText)+"|||")]),_c('strike',[_vm._v(_vm._s(_vm.fieldSupplier))]),_vm._v(" "+_vm._s(_vm.correctedText)+" ")],1):_c('span',[_vm._v(_vm._s(_vm.fieldSupplier))])
}
var staticRenderFns = []

export { render, staticRenderFns }